interface SEOHeadProps {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl: string;
  ogType?: string;
  ogImage?: string;
  articlePublishedTime?: string;
  articleModifiedTime?: string;
}

export function SEOHead({ title, description, keywords, canonicalUrl, ogType = 'website', ogImage, articlePublishedTime, articleModifiedTime }: SEOHeadProps) {
  const fullTitle = `${title} - 韩漫网`;
  const fullOgImage = ogImage || 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20website%20banner%2C%20colorful%20comic%20book%20illustrations%20collage%2C%20warm%20inviting%20atmosphere%2C%20clean%20modern%20design%2C%20professional%20digital%20art&width=1200&height=630&seq=og-default&orientation=landscape';

  const schemaData: Record<string, unknown> = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: '韩漫网',
        url: 'https://www.hanmanwang.com',
        description: '全网最全最新最好看的无删减韩国漫画网站，资源齐全画质优良，是您漫画收藏的理想之地。',
        email: 'contact@hanmanwang.com',
        telephone: '400-888-6666',
        address: {
          '@type': 'PostalAddress',
          addressLocality: '北京',
          addressRegion: '朝阳区',
          streetAddress: '望京SOHO T3-A座 2501室',
        },
      },
      {
        '@type': 'WebSite',
        name: '韩漫网',
        url: 'https://www.hanmanwang.com',
        description: '全网最全无删减韩国漫画在线阅读平台',
      },
      {
        '@type': 'WebPage',
        name: fullTitle,
        description: description,
        url: canonicalUrl,
      },
    ],
  };

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={`${keywords},韩国漫画,韩漫,无删减漫画,免费漫画`} />
      <link rel="canonical" href={canonicalUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={fullOgImage} />
      <meta property="og:site_name" content="韩漫网" />
      <meta property="og:locale" content="zh_CN" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullOgImage} />
      {articlePublishedTime && <meta property="article:published_time" content={articlePublishedTime} />}
      {articleModifiedTime && <meta property="article:modified_time" content={articleModifiedTime} />}
      <script type="application/ld+json">
        {JSON.stringify(schemaData)}
      </script>
    </>
  );
}

export function generateBreadcrumbSchema(items: { name: string; url: string }[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, idx) => ({
      '@type': 'ListItem',
      position: idx + 1,
      name: item.name,
      item: item.url,
    })),
  };
}

export function generateArticleSchema(article: {
  title: string;
  description: string;
  image: string;
  url: string;
  publishedDate: string;
  modifiedDate: string;
  author: string;
}) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: article.title,
    description: article.description,
    image: article.image,
    url: article.url,
    datePublished: article.publishedDate,
    dateModified: article.modifiedDate,
    author: {
      '@type': 'Person',
      name: article.author,
    },
    publisher: {
      '@type': 'Organization',
      name: '韩漫网',
    },
  };
}

export function generateFAQSchema(faqs: { question: string; answer: string }[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map(faq => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };
}